import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Users } from '@/types/general';
import { useTranslation } from "react-i18next";

export interface InvitationWithExpiry extends Users.DTO.CompanyInvitations {
    expiryStatus?: dayjs.Dayjs | React.ReactNode; // Can be a string or the timer component
}

const calculateInitialExpiryStatus = (invitedAt: dayjs.Dayjs | undefined, expirationDays: number | undefined): string | null => {
    const { t } = useTranslation("", { keyPrefix: "settings.general.companyInformation.tabs.users.inviteUsersTable.table" });
    
    if (!invitedAt || expirationDays === undefined) {
        return null;
    }
    const expiryDate = dayjs(invitedAt).add(expirationDays, 'day');
    const now = dayjs();
    const difference = expiryDate.diff(now);
    const durationLeft = dayjs.duration(difference);

    if (difference < 0) {
        return `${t("inviteStatus.expired")}`;
    } else if (durationLeft.asDays() >= 1) {
        return dayjs.duration(difference).humanize(false);
    } else {
        const hours = durationLeft.hours();
        const minutes = durationLeft.minutes();
        return `${dayjs.duration(hours, 'hours').humanize(false)} ${dayjs.duration(minutes, 'minutes').humanize(false)}`;
    }
    return null;
};

export const ExpiryCountdown = ({ invitedAt, expirationDays }: { invitedAt?: dayjs.Dayjs; expirationDays?: number }) => {
    const [expiryStatus, setExpiryStatus] = useState<string | null>(calculateInitialExpiryStatus(invitedAt, expirationDays));

    useEffect(() => {
        if (invitedAt && expirationDays !== undefined && expiryStatus !== 'Expired') {
            const intervalId = setInterval(() => {
                const status = calculateInitialExpiryStatus(invitedAt, expirationDays);
                setExpiryStatus(status);
                if (status === 'Expired') {
                    clearInterval(intervalId);
                }
            }, 60000); // Update every minute

            return () => clearInterval(intervalId);
        }
    }, [invitedAt, expirationDays, expiryStatus]);

    return <>{expiryStatus}</>;
};